/**
 * Helpers de data para respostas da API de Custom Targeting.
 *
 * O backend grava os timestamps com `datetime.utcnow()` e os serializa sem
 * indicador de fuso — por exemplo "2026-01-27T17:48:01.641000". O valor é UTC,
 * mas o JavaScript interpreta uma string nesse formato como horário LOCAL, o
 * que jogaria as datas 3 horas para frente no Brasil. Por isso o `Z` é anexado
 * antes do parse.
 */

/** Já traz fuso: sufixo Z, ou offset +hh:mm / -hh:mm depois da parte de hora. */
const HAS_TIMEZONE = /(?:Z|[+-]\d{2}:?\d{2})$/i;

/**
 * Converte um timestamp vindo da API em Date, tratando-o como UTC quando o
 * fuso não é informado. Devolve null para entradas ausentes ou inválidas.
 */
export function parseApiDate(raw?: string | null): Date | null {
    if (!raw) return null;

    const normalized = HAS_TIMEZONE.test(raw) ? raw : `${raw}Z`;
    const parsed = new Date(normalized);

    return Number.isNaN(parsed.getTime()) ? null : parsed;
}

/** Formata a data no fuso do navegador, com dia e hora. */
export function formatDateTime(date: Date | null): string {
    if (!date) return '—';
    return date.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
}

/** Versão curta (dia/mês + hora), para caber na linha da listagem. */
export function formatDateTimeShort(date: Date | null): string {
    if (!date) return '—';
    return date.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    });
}
